import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../utils/hostname";
import url from "../url";

type BodyLoyaltyRewardAssign = {
  loyaltyId: string;
  rewardId: string;
  loyaltyRewardId: string;
};

export type MutationRewardAssignBody = Omit<
  BodyLoyaltyRewardAssign,
  "loyaltyId"
>;

const requestLoyaltyRewardAssign = (body: BodyLoyaltyRewardAssign) =>
  api(true, true).post(url.config.api.loyalty.userRewardAssign, body);

export const useLoyaltyRewardAssign = (loyaltyId: string) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["reward assign"],
    mutationFn: (body: MutationRewardAssignBody) =>
      requestLoyaltyRewardAssign({
        loyaltyId,
        rewardId: body.rewardId,
        loyaltyRewardId: body.loyaltyRewardId,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["loyalty rewards user"],
      });
    },
  });

  return {
    handleAssignReward: mutate,
    isPending,
  };
};
